<template>
  <div class="import-products-excel-tab">
    <p class="mb-4 text-sm text-gray-600">
      {{ $t("promotions.products.excelHint") }}
    </p>

    <OurFileInput
      :label="$t('promotions.products.importExcel')"
      :files="files"
      :allowed-file-types="allowedFileTypes"
      @changeFiles="onChangeFiles"
      @deleteFile="onDeleteFile"
    />
  </div>
</template>

<script>
export default {
  name: "ImportProductsExcelTab",

  data() {
    return {
      files: [],
      allowedFileTypes: [".xlsx", ".xls"],
    };
  },

  methods: {
    onChangeFiles(selectedFiles) {
      if (!selectedFiles?.length) {
        return;
      }

      this.$emit("import-file", selectedFiles[0]);
      this.files = [];
    },

    onDeleteFile() {
      this.files = [];
    },
  },
};
</script>
